jQuery(document).ready(function($) {

    $( ".bloc_paraphotos" ).each(function( index ) {

        var $bloc = $(this);
        var cibleParaPhoto = $bloc.find(".visuel")
        var texteParaPhoto = $bloc.find(".texte")

        // Zoom d'entrée plus léger sous 1024px : à 1.8 la photo, étroite,
        // est méconnaissable pendant presque tout le scroll
        var isMobile = window.matchMedia("(max-width: 1023.98px)").matches

        gsap.from( cibleParaPhoto , {
            scale: isMobile ? 1.25 : 1.8,
            scrollTrigger: {
                trigger: cibleParaPhoto,
                start: 'top 100%',
                end: 'top 50%',
                scrub: 1,
                markers: false
            }
        })

        gsap.from(texteParaPhoto, {
            opacity : 0,
            duration: .6,
            y: isMobile ? 50 : 100,
            ease: "power1.out",
            scrollTrigger: {
                trigger: texteParaPhoto,
                markers: false,
                start: "top bottom"
            }

        });


        var cibleLogoLeft = $bloc.find(".fadeInLeft")

        gsap.from( cibleLogoLeft , {
            opacity: 0,
            x: -100,
            scrollTrigger: {
                trigger: cibleLogoLeft,
                start: 'top 100%',
                end: 'top 0%',
                scrub: 1,
                markers: false
            }
        })

        var cibleLogoRight = $bloc.find(".fadeInRight")

        gsap.from( cibleLogoRight , {
            opacity: 0,
            x: +100,
            scrollTrigger: {
                trigger: cibleLogoRight,
                start: 'top 100%',
                end: 'top 0%',
                scrub: 1,
                markers: false
            }
        })

        // Carousel des visuels (fonction factorisée dans 19_carousel.js)
        initPcCarousel($bloc, { delay: 3500 });

    })

});
